(function() {
  'use strict';
  // --- Delay-Konfiguration ---
  const AUTOADD_DELAY_MS     = 10;               // Wartezeit in ms für Updates
  // --- Varianten-Konfiguration ---
  const triggerVariantId      = '50881013809489';  // auslösende Variante
  const targetVariantId       = '51038948458833';  // automatisch hinzuzufügende Variante
  const cartDrawerSectionId   = 'cart-drawer';     // Section-ID im Drawer
  const drawerElementSelector = '#CartDrawer';     // CSS-Selektor des Drawers
  const drawerOpenSelector    = '[data-drawer-toggle="cart-drawer"]';
  let isAddingTarget = false;

  // --- Für Tests: Fake-Cart, falls gesetzt ---
  window._autoAddFakeCart = null;

  // --- Warenkorb-UI aktualisieren ---
  function updateCartUI() {
    console.log('▶ updateCartUI → fetch /cart?section_id=', cartDrawerSectionId);
    fetch(`/cart?section_id=${cartDrawerSectionId}`)
      .then(res => {
        console.log(' updateCartUI: status', res.status);
        if (!res.ok) throw new Error(`Section fetch failed: ${res.status}`);
        return res.text();
      })
      .then(html => {
        const drawer = document.querySelector(drawerElementSelector);
        if (!drawer) {
          console.error(' updateCartUI: Drawer nicht gefunden');
          return;
        }
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const newContent =
          temp.querySelector(`#shopify-section-${cartDrawerSectionId} ${drawerElementSelector}`) ||
          temp.querySelector(`#shopify-section-${cartDrawerSectionId}`) ||
          temp.querySelector(drawerElementSelector);
        drawer.innerHTML = newContent ? newContent.innerHTML : html;
        document.body.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        drawer.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        // Drawer öffnen nach kurzem Delay
        setTimeout(() => {
          const toggle = document.querySelector(drawerOpenSelector);
          if (toggle) toggle.click();
        }, AUTOADD_DELAY_MS);
      })
      .catch(err => console.error(' updateCartUI Error:', err));
  }

  // --- Ziel-Produkte mit Trigger-Produkten synchronisieren ---
  function syncTargetProducts() {
    console.log('▶ syncTargetProducts gestartet');
    if (isAddingTarget) {
      console.log(' syncTargetProducts: bereits aktiv → Abbruch');
      return;
    }
    isAddingTarget = true;

    const cartPromise = window._autoAddFakeCart
      ? Promise.resolve(window._autoAddFakeCart)
      : fetch('/cart.js').then(res => {
          console.log(' syncTargetProducts: /cart.js status', res.status);
          if (!res.ok) throw new Error(`Cart fetch failed: ${res.status}`);
          return res.json();
        });

    cartPromise
      .then(cart => {
        console.log(' syncTargetProducts: Warenkorb-Items:', cart.items);
        const triggerQty = cart.items
          .filter(i => i.variant_id.toString() === triggerVariantId)
          .reduce((sum, i) => sum + i.quantity, 0);
        const targetQty = cart.items
          .filter(i => i.variant_id.toString() === targetVariantId)
          .reduce((sum, i) => sum + i.quantity, 0);
        const diff = triggerQty - targetQty;
        console.log(` triggerQty=${triggerQty}, targetQty=${targetQty}, diff=${diff}`);

        if (diff > 0) {
          console.log(` füge ${diff} Ziel-Variante(n) hinzu`);
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
            body: JSON.stringify({ items: [{ id: targetVariantId, quantity: diff }] })
          });
        } else {
          console.log(' keine Aktion nötig');
        }
      })
      .then(res => {
        if (res) console.log(' syncTargetProducts: Add-Response', res.status);
      })
      .then(updateCartUI)
      .catch(err => {
        console.error(' syncTargetProducts Error:', err);
        updateCartUI();
      })
      .finally(() => {
        console.log(' syncTargetProducts: fertig');
        isAddingTarget = false;
      });
  }

  // --- Verarbeitung der /cart/add Response ---
  function handleCartAddResponse(text) {
    console.log('▶ handleCartAddResponse raw:', text);
    if (isAddingTarget) {
      console.log(' handleCartAddResponse: skip, isAddingTarget');
      return;
    }
    let addedVariant = null;
    try {
      const data = JSON.parse(text);
      addedVariant =
        (data.variant_id && data.variant_id.toString()) ||
        (data.items?.[0]?.variant_id.toString()) ||
        (Array.isArray(data) && data[0]?.variant_id.toString());
    } catch(e) {
      console.error(' handleCartAddResponse Parse-Error:', e);
    }
    console.log(' handleCartAddResponse: addedVariantId =', addedVariant);
    if (addedVariant === triggerVariantId) {
      console.log(' Trigger erkannt → syncTargetProducts');
      setTimeout(syncTargetProducts, AUTOADD_DELAY_MS);
    }
  }

  // --- Monkey-Patch für fetch: /add, /change, /update ---
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const [resource, config] = args;
    let url = '', method = 'GET';
    if (typeof resource === 'string') url = resource;
    else if (resource instanceof Request) { url = resource.url; method = resource.method; }
    if (config?.method) method = config.method.toUpperCase();

    const isAdd    = url.includes('/cart/add')    && method === 'POST';
    const isChange = url.includes('/cart/change') && method === 'POST';
    const isUpdate = url.includes('/cart/update') && method === 'POST';

    const promise = originalFetch.apply(this, args);

    if (isAdd) {
      console.log('fetch-patch: /cart/add erkannt');
      promise
        .then(res => res.clone().text())
        .then(text => handleCartAddResponse(text))
        .catch(err => console.error('fetch-patch Error:', err));
    } else if (isChange || isUpdate) {
      console.log(`fetch-patch: ${isChange?'/cart/change':'/cart/update'} erkannt`);
      promise
        .then(res => res.clone().text())
        .then(txt => {
          console.log(' raw change/update response:', txt);
          setTimeout(syncTargetProducts, AUTOADD_DELAY_MS);
        })
        .catch(err => console.error('fetch-patch Error:', err));
    }

    return promise;
  };

  // --- Monkey-Patch für XMLHttpRequest: /add, /change, /update ---
  try {
    if (window.XMLHttpRequest) {
      const origOpen = XMLHttpRequest.prototype.open;
      const origSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function(method, url) {
        this._method = method.toUpperCase();
        this._url    = url;
        return origOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function() {
        const xhr = this;
        const m = xhr._method, u = xhr._url || '';
        const isAddX    = u.includes('/cart/add')    && m === 'POST';
        const isChangeX = u.includes('/cart/change') && m === 'POST';
        const isUpdateX = u.includes('/cart/update') && m === 'POST';

        if (isAddX || isChangeX || isUpdateX) {
          console.log(`XHR-patch: ${isAddX?'/add':isChangeX?'/change':'/update'} erkannt`);
          const prev = xhr.onreadystatechange;
          xhr.onreadystatechange = function() {
            if (xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 300) {
              if (isAddX) {
                handleCartAddResponse(xhr.responseText);
              } else {
                console.log(' raw XHR change/update response:', xhr.responseText);
                setTimeout(syncTargetProducts, AUTOADD_DELAY_MS);
              }
            }
            return prev && prev.apply(this, arguments);
          };
        }
        return origSend.apply(this, arguments);
      };
    }
  } catch(e) {
    console.warn('XHR-Patch fehlgeschlagen', e);
  }

  // --- Test-Helpers und Abschluss-Log ---
  window._syncTargetProducts    = syncTargetProducts;
  window._updateCartUI          = updateCartUI;
  window._handleCartAddResponse = handleCartAddResponse;
  window._setFakeCart           = function(triggerQty, targetQty) {
    const items = [];
    if (triggerQty > 0) items.push({ variant_id: parseInt(triggerVariantId), quantity: triggerQty });
    if (targetQty  > 0) items.push({ variant_id: parseInt(targetVariantId),  quantity: targetQty  });
    window._autoAddFakeCart = { items };
    console.log('✅ Fake-Cart gesetzt:', window._autoAddFakeCart.items);
  };

  console.log('✅ Auto-Add-Script geladen');
})();
